import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { tomos, IMAGES } from '../data/content';
export function Tomos() {
  return <section className="w-full bg-navy px-4 py-14 text-white sm:py-20" data-id="element-248" data-mp="1h3w0tm20eies">
      <div className="mx-auto w-full max-w-2xl" data-id="element-249" data-mp="1cbuet8f1hdbk">
        <p className="text-center text-[11px] font-semibold uppercase tracking-[0.2em] text-gold-light" data-id="element-250" data-mp="1cb2x91ia1g4a">
          📦 Qué contiene
        </p>
        <h2 className="mt-3 text-center font-display text-[1.65rem] font-bold leading-tight sm:text-4xl" data-id="element-251" data-mp="1m2fktgx1lk4i">
          No recibirás un ebook. Recibirás un sistema completo de consulta clínica.
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-white/70 sm:text-lg" data-id="element-252" data-mp="1vzttgucq54m9">
          Cada tomo resuelve una etapa específica de la consulta. Cada algoritmo elimina una duda.
          Cada protocolo reduce la incertidumbre.
        </p>

        <img src={IMAGES.mockup} alt="Colección completa de los 6 tomos de la Ruta Clínica de Menopausia" className="mx-auto mt-8 w-full max-w-md" data-id="element-253" data-mp="1ootc00ujabo" />

        <div className="mt-8 space-y-4" data-id="element-254" data-mp="39nqeep9seyfh">
          {tomos.map((t, i) => <motion.article key={t.n} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.4,
          delay: i % 2 * 0.05
        }} className="rounded-2xl border border-white/10 bg-white/[0.06] p-5" data-id="element-255" data-mp="3enbcyyl1p4ro" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-256" data-mp="19hndlmwyfpf">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gold font-display text-base font-bold text-navy-deep" data-id="element-257" data-mp="17wt7x4igys3">
                  {t.n}
                </span>
                <div data-id="element-258" data-mp="233gxi3oaur0j">
                  <p className="flex items-center gap-1 text-[10px] font-bold uppercase tracking-[0.18em] text-gold-light" data-id="element-259" data-mp="2807eqububsnj">
                    <BookOpenIcon className="h-3 w-3" aria-hidden="true" data-id="element-260" data-mp="1zyzute5ni4ez" /> Tomo {t.n}
                  </p>
                  <h3 className="font-display text-lg font-bold leading-tight sm:text-xl" data-id="element-261" data-mp="1vz7rbfv46ogh">
                    {t.title}
                  </h3>
                </div>
              </div>
              <p className="mt-3 text-sm font-semibold text-gold-light sm:text-base" data-id="element-262" data-mp="24yl2ccyvzl3b">{t.lead}</p>
              <p className="mt-1.5 text-sm leading-relaxed text-white/70 sm:text-base" data-id="element-263" data-mp="2ixu6ufdqcqrg">{t.text}</p>
              <ul className="mt-3 grid grid-cols-1 gap-1.5 sm:grid-cols-2" data-id="element-264" data-mp="2exttky2dallz">
                {t.bullets.map(b => <li key={b} className="flex items-center gap-1.5 text-[13px] text-white/80 sm:text-sm" data-id="element-265" data-mp="2sn3yxv8kq9fk">
                    <CheckIcon className="h-3.5 w-3.5 shrink-0 text-gold" aria-hidden="true" data-id="element-266" data-mp="32mczx81uwobf" />
                    {b}
                  </li>)}
              </ul>
            </motion.article>)}
        </div>

        <div className="mt-9" data-id="element-267" data-mp="3had030u9bt4p">
          <CTAButton label="Quiero los 6 tomos ahora" note="Descarga digital inmediata" data-id="element-268" data-mp="3h77c5oxd6xak" />
        </div>
      </div>
    </section>;
}